/* tslint:disable */
/* eslint-disable */
/**
 * Swipe4Work Employer API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the EditUserCommentCommandDto interface.
 */
export function instanceOfEditUserCommentCommandDto(value) {
    if (!('body' in value) || value['body'] === undefined)
        return false;
    return true;
}
export function EditUserCommentCommandDtoFromJSON(json) {
    return EditUserCommentCommandDtoFromJSONTyped(json, false);
}
export function EditUserCommentCommandDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'body': json['body'],
    };
}
export function EditUserCommentCommandDtoToJSON(json) {
    return EditUserCommentCommandDtoToJSONTyped(json, false);
}
export function EditUserCommentCommandDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'body': value['body'],
    };
}
